//   import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
//   import FlightHome from './Screenss/Flighthome';
//   import Ourscreen from './Component/Ourscreen';
//   import MissionVision from './Component/Missionvision';
//  import AimsObjectives from './Component/Aimsobjective';
//  import Facilities from './Component/Facilities';
//  import SportsFitness from './Component/SportsFitness';
//  import Activities from './Component/Activities';
//  import ContactUs from './Component/ContactUs';
//   import UploadContent from './Screenss/Uplaod';
//   import Header from './Screenss/Header';
// import './App.css';

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           {/* Abhi sirf Home Screen hi load hogi */}
//               {/* <Route path="/" element={<UploadContent/>} /> */}
//           <Route path="/" element={<FlightHome/>} />
//         <Route path="/ourscreen" element={<Ourscreen/>} />
//         <Route path="/Missionvision" element={<MissionVision/>} />
//         <Route path="/AimsObjectives" element={<AimsObjectives/>} />
//         <Route path="/Facilities" element={<Facilities/>} />
//         <Route path="/SportsFitness" element={<SportsFitness/>} />
//           <Route path="/Activities" element={<Activities/>} />
//               <Route path="/ContactUs" element={<ContactUs/>} />
//           {/* Future mein aap yahan aur routes add kar sakte hain */}
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import FlightHome from './Screenss/Flighthome';
// import Ourscreen from './Component/Ourscreen';
// import MissionVision from './Component/Missionvision';
// import AimsObjectives from './Component/Aimsobjective';
// import Facilities from './Component/Facilities';
// import SportsFitness from './Component/SportsFitness';
// import Activities from './Component/Activities';
// import ContactUs from './Component/ContactUs';
// import Header from './Screenss/Header';
// import { DataContext } from './Screenss/DataContext';
// import './App.css';

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         {/* ✅ Header ko Router ke andar aur Routes ke bahar rakha hai */}
//         {/* Isse ye har screen par dikhega aur navigation bhi sahi chalegi */}
//         <Header />

//         <Routes>
//           <Route path="/" element={<FlightHome />} />
//           <Route path="/ourscreen" element={<Ourscreen />} />
//           <Route path="/Missionvision" element={<MissionVision />} />
//           <Route path="/AimsObjectives" element={<AimsObjectives />} />
//           <Route path="/Facilities" element={<Facilities />} />
//           <Route path="/SportsFitness" element={<SportsFitness />} />
//           <Route path="/Activities" element={<Activities />} />
//           <Route path="/ContactUs" element={<ContactUs />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import FlightHome from "./Screenss/Flighthome";
// import Ourscreen from "./Component/Ourscreen";
// import MissionVision from "./Component/Missionvision";
// import AimsObjectives from "./Component/Aimsobjective";
// import Facilities from "./Component/Facilities";
// import SportsFitness from "./Component/SportsFitness";
// import Activities from "./Component/Activities";
// import ContactUs from "./Component/ContactUs";
// import Header from "./Screenss/Header";
// import PrincipalMessage from "./Component/PrincipalMessage";
// import ShowGallery from "./Component/Showgallary";
// import StaffSection from "./Component/StaffSection";
// // ✅ IMPORTANT: DataProvider import karo
// import { DataProvider } from "./Screenss/DataContext";
// import TransportSection from "./Component/TransportSection";
// import DirectorMessage from "./Screenss/DirectorMessage";
// import "./App.css";

// function App() {
//   return (
//     // ✅ GLOBAL DATA WRAP
//     <DataProvider>
//       <Router>
//         <div className="App">
          
//           {/* HEADER (har page pe dikhega) */}
//           <Header />

//           <Routes>
//             <Route path="/" element={<FlightHome />} />
//             <Route path="/ourscreen" element={<Ourscreen />} />
//             <Route path="/Missionvision" element={<MissionVision />} />
//             <Route path="/AimsObjectives" element={<AimsObjectives />} />
//             <Route path="/Facilities" element={<Facilities />} />
//             <Route path="/SportsFitness" element={<SportsFitness />} />
//             <Route path="/Activities" element={<Activities />} />
//             <Route path="/ContactUs" element={<ContactUs />} />
//             <Route path="/PrincipalMessage" element={<PrincipalMessage/>} />
//              <Route path="/ShowGallery" element={<ShowGallery/>} />
//               <Route path="/StaffSection" element={<StaffSection/>} />
//               <Route path="/TransportSection" element={<TransportSection/>} />
//               <Route path="/DirectorMessage" element={<DirectorMessage/>} />
//           </Routes>

//         </div>
//       </Router>
//     </DataProvider>
//   );
// }

// export default App;

// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// import FlightHome from "./Screenss/Flighthome";
// import Ourscreen from "./Component/Ourscreen";
// import MissionVision from "./Component/Missionvision";
// import AimsObjectives from "./Component/Aimsobjective";
// import Facilities from "./Component/Facilities";
// import SportsFitness from "./Component/SportsFitness";
// import Activities from "./Component/Activities";
// import ContactUs from "./Component/ContactUs";
// import Header from "./Screenss/Header";
// import PrincipalMessage from "./Component/PrincipalMessage";
// import ShowGallery from "./Component/Showgallary";
// import StaffSection from "./Component/StaffSection";
// import TransportSection from "./Component/TransportSection";
// import DirectorMessage from "./Screenss/DirectorMessage";
// import DirectorMessages from "./Component/Directormsg";
// import { DataProvider } from "./Screenss/DataContext";
// import "./App.css";

// function App() {
//   return (
//     <DataProvider>
//        <BrowserRouter basename="/Dpsschool_Data/dpsladwa">
//         <div className="App">

//           {/* HEADER */}
//           <Header />

//           <Routes>
//             <Route path="/" element={<FlightHome/>} />
//             <Route path="/ourscreen" element={<Ourscreen />} />
//             <Route path="/missionvision" element={<MissionVision />} />
//             <Route path="/aimsobjectives" element={<AimsObjectives />} />
//             <Route path="/facilities" element={<Facilities />} />
//             <Route path="/sportsfitness" element={<SportsFitness />} />
//             <Route path="/activities" element={<Activities />} />
//             <Route path="/contactus" element={<ContactUs />} />
//             <Route path="/principalmessage" element={<PrincipalMessage />} />
//             <Route path="/showgallery" element={<ShowGallery />} />
//             <Route path="/staffsection" element={<StaffSection />} />
//             <Route path="/transportsection" element={<TransportSection />} />
//             <Route path="/directormessage" element={<DirectorMessages/>} />
//           </Routes>

//         </div>
//       </BrowserRouter>
//     </DataProvider>
//   );
// }

// export default App;
// import React from "react";
// import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// import FlightHome from "./Screenss/Flighthome";
// import Ourscreen from "./Component/Ourscreen";
// import MissionVision from "./Component/Missionvision";
// import AimsObjectives from "./Component/Aimsobjective";
// import Facilities from "./Component/Facilities";
// import SportsFitness from "./Component/SportsFitness";
// import Activities from "./Component/Activities";
// import ContactUs from "./Component/ContactUs";
// import Header from "./Screenss/Header";
// import PrincipalMessage from "./Component/PrincipalMessage";
// import ShowGallery from "./Component/Showgallary";
// import StaffSection from "./Component/StaffSection";
// import TransportSection from "./Component/TransportSection";
// import DirectorMessages from "./Component/Directormsg";
// import { DataProvider } from "./Screenss/DataContext";
// import SplashScreen from "./Component/Spleshscreen";

// import Footer from "./Screenss/Footer";
// function Layout() {
//   const location = useLocation();

//   return (
//     <>
//       {/* ❌ Splash pe header hide */}
//       {location.pathname !== "/" && <Header />}

//       <Routes>
//         {/* Splash */}
//         <Route path="/" element={<SplashScreen />} />

//         {/* Main Pages */}
//         <Route path="/home" element={<FlightHome />} />
//         <Route path="/ourscreen" element={<Ourscreen />} />
//         <Route path="/missionvision" element={<MissionVision />} />
//         <Route path="/aimsobjectives" element={<AimsObjectives />} />
//         <Route path="/facilities" element={<Facilities />} />
//         <Route path="/sportsfitness" element={<SportsFitness />} />
//         <Route path="/activities" element={<Activities />} />
//         <Route path="/contactus" element={<ContactUs />} />
//         <Route path="/principalmessage" element={<PrincipalMessage />} />
//         <Route path="/showgallery" element={<ShowGallery />} />
//         <Route path="/staffsection" element={<StaffSection />} />
//         <Route path="/transportsection" element={<TransportSection />} />
//         <Route path="/directormessage" element={<DirectorMessages />} />
//       </Routes>
//         {location.pathname !== "/" && <Footer/>}
//     </>
//   );
// }

// function App() {
//   return (
//     <DataProvider>
//       <BrowserRouter basename="/Dpsschool_Data/dpsladwa">
//         <Layout />
//       </BrowserRouter>
//     </DataProvider>
//   );
// }

// export default App;

// import React, { useEffect } from "react";
// import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";

// import FlightHome from "./Screenss/Flighthome";
// import Ourscreen from "./Component/Ourscreen";
// import MissionVision from "./Component/Missionvision";
// import AimsObjectives from "./Component/Aimsobjective";
// import Facilities from "./Component/Facilities";
// import SportsFitness from "./Component/SportsFitness";
// import Activities from "./Component/Activities";
// import ContactUs from "./Component/ContactUs";
// import Header from "./Screenss/Header";
// import PrincipalMessage from "./Component/PrincipalMessage";
// import ShowGallery from "./Component/Showgallary";
// import StaffSection from "./Component/StaffSection";
// import TransportSection from "./Component/TransportSection";
// import DirectorMessages from "./Component/Directormsg";
// import { DataProvider } from "./Screenss/DataContext";
// import SplashScreen from "./Component/Spleshscreen";
// import Footer from "./Screenss/Footer";
// import MandatoryDisclosure from "./Component/MandatoryDisclosure";
// import FeesStructure from "./Screenss/FeeStructure";
 
// // 👇 Splash Controller Route
// function SplashRedirect() {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       navigate("/homee");
//     }, 2000);

//     return () => clearTimeout(timer);
//   }, [navigate]);

//   return <SplashScreen />;
// }

// function Layout() {
//   const location = useLocation();

//   return (
//     <>
//       {location.pathname !== "/" && <Header />}

//       <Routes>
//         {/* Splash only first route */}
//         {/* <Route path="/" element={<SplashRedirect />} /> */}

//         {/* Main Pages */}
//         <Route path="/" element={<FlightHome />} />
//         <Route path="/ourscreen" element={<Ourscreen />} />
         
//         <Route path="/missionvision" element={<MissionVision />} />
//         <Route path="/aimsobjectives" element={<AimsObjectives />} />
//         <Route path="/facilities" element={<Facilities />} />
//         <Route path="/sportsfitness" element={<SportsFitness />} />
//         <Route path="/activities" element={<Activities />} />
//         <Route path="/contactus" element={<ContactUs />} />
//         <Route path="/principalmessage" element={<PrincipalMessage />} />
//         <Route path="/showgallery" element={<ShowGallery />} />
//         <Route path="/staffsection" element={<StaffSection />} />
//         <Route path="/transportsection" element={<TransportSection />} />
//         <Route path="/directormessage" element={<DirectorMessages />} />
//         <Route path="/fees" element={<FeesStructure />} />
//       </Routes>

//       {location.pathname !== "/" && <Footer />}
//     </>
//   );
// }

// function App() {
//   return (
//     <DataProvider>
//       <BrowserRouter>
//         <Layout />
//       </BrowserRouter>
//     </DataProvider>
//   );
// }

// export default App;

import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import ScrollToTop from "./Component/Scrollontop";
// Screens / Components
import FlightHome from "./Screenss/Flighthome";
import Ourscreen from "./Component/Ourscreen";
import MissionVision from "./Component/Missionvision";
import AimsObjectives from "./Component/Aimsobjective";
import Facilities from "./Component/Facilities";
import SportsFitness from "./Component/SportsFitness";
import Activities from "./Component/Activities";
import ContactUs from "./Component/ContactUs";
import Header from "./Screenss/Header";
import PrincipalMessage from "./Component/PrincipalMessage";
import ShowGallery from "./Component/Showgallary";
import StaffSection from "./Component/StaffSection";
import TransportSection from "./Component/TransportSection";
import DirectorMessages from "./Component/Directormsg";
import { DataProvider } from "./Screenss/DataContext";
import SplashScreen from "./Component/Spleshscreen";
import Footer from "./Screenss/Footer";
import MandatoryDisclosure from "./Component/MandatoryDisclosure";
import FeesStructure from "./Screenss/FeeStructure";
import SchoolCertificates from "./Component/Schoolcertificates";
// 👇 Splash Controller Route
function SplashRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/homee");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return <SplashScreen />;
}

// 👇 Main Layout
function Layout() {
  const location = useLocation();

  // ❌ yaha wo routes likh jahan header/footer nahi chahiye
  const hideLayoutRoutes = ["/mandatoryDis"];

  const hideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
    <ScrollToTop/>
      {/* Header */}
      {!hideLayout && <Header />}

      {/* Routes */}
      <Routes>
        <Route path="/" element={<FlightHome />} />
        <Route path="/ourscreen" element={<Ourscreen />} />
          <Route path="/SchoolCertificates" element={<SchoolCertificates/>} />
        <Route path="/missionvision" element={<MissionVision />} />
        <Route path="/aimsobjectives" element={<AimsObjectives />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/sportsfitness" element={<SportsFitness />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/principalmessage" element={<PrincipalMessage />} />
        <Route path="/showgallery" element={<ShowGallery />} />
        <Route path="/staffsection" element={<StaffSection />} />
        <Route path="/transportsection" element={<TransportSection />} />
        <Route path="/directormessage" element={<DirectorMessages />} />
        <Route path="/fees" element={<FeesStructure />} />

        {/* ✅ Special Page (no header/footer) */}
        <Route path="/mandatoryDis" element={<MandatoryDisclosure />} />
      </Routes>

      {/* Footer */}
      {!hideLayout && <Footer />}
    </>
  );
}

// 👇 App Root
function App() {
  return (
    <DataProvider>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;